import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const Counter = ({ endDate }) => {

	if (!endDate) return null;
	// Calculate how much time is left
	const calculateTimeLeft = () => {
		const now = new Date().getTime();
		const distance = new Date(endDate).getTime() - now;

		if (distance <= 0) {
			// If countdown has ended or is past
			return { days: 0, hours: 0, minutes: 0, seconds: 0 };
		}

		const days = Math.floor(distance / (1000 * 60 * 60 * 24));
		const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
		const minutes = Math.floor((distance / (1000 * 60)) % 60);
		const seconds = Math.floor((distance / 1000) % 60);

		return { days, hours, minutes, seconds };
	};

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

	useEffect(() => {
		// Update the countdown every second
		const timerId = setInterval(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);

		// Cleanup interval on unmount
		return () => clearInterval(timerId);
	}, [endDate]);

	// Format days
	// - If greater than or equal to 100, display as is (e.g., 365)
	// - If less than 100, show 2 digits (e.g., 09)
	const formatDays = (days) => {
		if (days >= 100) {
			return String(days); // e.g. 100 => "100"
		}
		return String(days).padStart(2, "0"); // e.g. 9 => "09"
	};

	// Format any number to exactly two digits (hours, minutes, seconds)
	const formatTwoDigits = (num) => String(num).padStart(2, "0");

	const daysStr = formatDays(timeLeft.days);
	const hoursStr = formatTwoDigits(timeLeft.hours);
	const minutesStr = formatTwoDigits(timeLeft.minutes);
	const secondsStr = formatTwoDigits(timeLeft.seconds);
	// format date to display April 16th, 2025 
	const displayDate = new Date(endDate).toLocaleString("en-US", {
		month: "long",
		day: "numeric",
		year: "numeric",
	});

	return (
		<div className="counter">
			<h2 className="counter__date">{displayDate}</h2>

			<div className="counter__countdown">
				{/* DAYS */}
				<div className="countdown-segment">
					<div className="countdown-segment__numbers">
						{daysStr.split("").map((digit, i) => (
							<p
								key={`days-digit-${i}`}
								className="countdown-segment__numbers__number"
							>
								{digit}
							</p>
						))}
						{/* <span className="counter__countdown__divider">:</span> */}
					</div>
					<p className="countdown-segment__label">Days</p>
				</div>
				<span className="counter__countdown__divider">:</span>

				{/* HOURS */}
				<div className="countdown-segment">
					<div className="countdown-segment__numbers">
						<p className="countdown-segment__numbers__number">{hoursStr[0]}</p>
						<p className="countdown-segment__numbers__number">{hoursStr[1]}</p>
					</div>
					<p className="countdown-segment__label">Hours</p>
				</div>
				<span className="counter__countdown__divider">:</span>

				{/* MINUTES */}
				<div className="countdown-segment">
					<div className="countdown-segment__numbers">
						<p className="countdown-segment__numbers__number">
							{minutesStr[0]}
						</p>
						<p className="countdown-segment__numbers__number">
							{minutesStr[1]}
						</p>
					</div>
					<p className="countdown-segment__label">Minutes</p>
				</div>
				<span className="counter__countdown__divider">:</span>

				{/* SECONDS */}
				<div className="countdown-segment">
					<div className="countdown-segment__numbers">
						<p className="countdown-segment__numbers__number">
							{secondsStr[0]}
						</p>
						<p className="countdown-segment__numbers__number">
							{secondsStr[1]}
						</p>
					</div>
					<p className="countdown-segment__label">Seconds</p>
				</div>
			</div>
		</div>
	);
};

Counter.propTypes = {
	endDate: PropTypes.string,
};

export default Counter;
